import { redirectToContractSales, redirectToPlan } from 'businessCommon/src/services';
import { lang, commonLang } from '@umu/ukit-lang';
import './pricingPartner.scss';
import React, { useCallback } from 'react';
import { IProps, PLAN_TYPE } from '@umu/umu-types';
import { If, Button, PreImg } from 'common/src/components';

let system = 'cn';

export type SystemType = 'cn' | 'en' | 'em' | 'jp' | 'tw';

export type UserLogoMapType = {
    [key in SystemType]: string;
};

export type UserLogoMapMobileType = {
    [key in SystemType]: string[];
};

const UserLogoMap: UserLogoMapType = {
    cn: require(`../../images/customer1.png`),
    en: require(`../../images/user-logo-en.png`),
    em: require(`../../images/user-logo-en.png`),
    jp: require(`../../images/user-logo-jp.png`),
    tw: require(`../../images/user-logo-tw.png`),
};

const UserLogoMapMobile: UserLogoMapMobileType = {
    cn: [
        require(`../../images/cnLogo/cnLogo1.png`),
        require(`../../images/cnLogo/cnLogo2.png`),
        require(`../../images/cnLogo/cnLogo3.png`),
        require(`../../images/cnLogo/cnLogo4.png`),
        require(`../../images/cnLogo/cnLogo5.png`),
        require(`../../images/cnLogo/cnLogo6.png`),
        require(`../../images/cnLogo/cnLogo7.png`),
        require(`../../images/cnLogo/cnLogo8.png`),
        require(`../../images/cnLogo/cnLogo9.png`),
        require(`../../images/cnLogo/cnLogo10.png`),
        require(`../../images/cnLogo/cnLogo11.png`),
        require(`../../images/cnLogo/cnLogo12.png`),
    ],

    en: [
        require(`../../images/comLogo/logo1.png`),
        require(`../../images/comLogo/logo7.png`),
        require(`../../images/comLogo/logo8.png`),
        require(`../../images/comLogo/logo3.png`),
        require(`../../images/comLogo/logo6.png`),
        require(`../../images/comLogo/logo9.png`),
        require(`../../images/comLogo/logo12.png`),
    ],

    em: [
        require(`../../images/comLogo/logo1.png`),
        require(`../../images/comLogo/logo7.png`),
        require(`../../images/comLogo/logo8.png`),
        require(`../../images/comLogo/logo3.png`),
        require(`../../images/comLogo/logo6.png`),
        require(`../../images/comLogo/logo9.png`),
        require(`../../images/comLogo/logo12.png`),
    ],

    jp: [
        require(`../../images/coLogo/coLogo1.png`),
        require(`../../images/coLogo/coLogo2.png`),
        require(`../../images/coLogo/coLogo3.png`),
        require(`../../images/coLogo/coLogo4.png`),
        require(`../../images/coLogo/coLogo5.png`),
        require(`../../images/coLogo/coLogo6.png`),
        require(`../../images/coLogo/coLogo8.png`),
        require(`../../images/coLogo/coLogo9.png`),
        require(`../../images/coLogo/coLogo10.png`),
        require(`../../images/coLogo/coLogo11.png`),
        require(`../../images/coLogo/coLogo12.png`),
    ],

    tw: [
        require(`../../images/twLogo/logo1.png`),
        require(`../../images/twLogo/logo2.png`),
        require(`../../images/twLogo/logo3.png`),
        require(`../../images/twLogo/logo5.png`),
        require(`../../images/twLogo/logo6.png`),
        require(`../../images/twLogo/logo7.png`),
        require(`../../images/twLogo/logo8.png`),
        require(`../../images/twLogo/logo9.png`),
        require(`../../images/twLogo/logo10.png`),
        require(`../../images/twLogo/logo11.png`),
        require(`../../images/twLogo/logo12.png`),
    ],
};

export const PricingPartner = (props: IProps) => {
    const { isRegisterUser, siteHost, platform } = props;
    const onPlan = useCallback(
        (planId: number) => {
            redirectToPlan(platform, isRegisterUser, planId);
        },
        [siteHost, isRegisterUser, platform],
    );

    const showCustomImage = () => {
        if (system === 'jp') {
            return (
                <PreImg>
                    <img className="partner-bg" src={UserLogoMap.jp} alt="" />
                </PreImg>
            );
        }

        const src = platform === 'mobile' ? UserLogoMapMobile[system as SystemType] : UserLogoMap[system as SystemType];
        if (typeof src === 'string') {
            return (
                <PreImg>
                    <img className="partner-bg" src={src} alt="" />
                </PreImg>
            );
        }
        return (
            <div className="img-list">
                {src.map((item) => (
                    <PreImg key={item}>
                        <img className="img-item" src={item} alt="" />
                    </PreImg>
                ))}
            </div>
        );
    };

    return (
        <>
            <If condition={platform === 'twww'}>
                <div className="pricing-partner">
                    <div className="partner-title">{lang('在全球，我们用效果学习为组织赋能')}</div>
                    <div className="partner-content-bg">{showCustomImage()}</div>
                </div>
            </If>
            <If condition={platform === 'mobile'}>
                <div className="pricing-m-partner">
                    <div className="partner-m-title">{lang('在全球，我们用效果学习为组织赋能')}</div>
                    {showCustomImage()}
                    <div className="partner-m-welcome-footer">
                        <div className="partner-m-welcome-title">{lang('欢迎使用 UMU')}</div>
                        <div className="partner-m-welcome-des">
                            {lang('现在就使用UMU提升学习效果')}
                            <br />
                            {lang('创造教与学的全新体验')}
                        </div>
                        <div className="partner-m-footer-btn">
                            <If condition={isRegisterUser}>
                                <Button
                                    onClick={() => redirectToContractSales(platform)}
                                    className="contact-btn contact-btn-top"
                                    alias="striking"
                                >
                                    {commonLang('联系 UMU')}
                                </Button>
                            </If>
                            <If condition={!isRegisterUser}>
                                <>
                                    <Button
                                        className="free-btn"
                                        onClick={() => onPlan(PLAN_TYPE.BASIC)}
                                        alias="striking"
                                    >
                                        {commonLang('免费注册')}
                                    </Button>
                                    <Button
                                        onClick={() => redirectToContractSales(platform)}
                                        className="contact-btn"
                                        alias="striking"
                                    >
                                        {commonLang('联系 UMU')}
                                    </Button>
                                </>
                            </If>
                        </div>
                    </div>
                    <PreImg>
                        <img className="partner-m-bg" src={require(`./images/down-m-bg.png`)} alt="" />
                    </PreImg>
                </div>
            </If>
        </>
    );
};
